import React from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          maxHeight="800px"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyStart
          alignCenter
        >
          <CFImage
            src={heroText}
            w="90%"
            alt="One Sushi Japanese Restaurant About"
            mt="15px"
          />
          <CFView pulsate mt="20px" textCenter>
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView
            row
            center
            bg="rgba(0,0,0,0.5)"
            p="20px 40px"
            w="100%"
            maxWidth="1000px"
            h="60px"
          >
            <CFView white h1 mr="15px" textCenter xBold mb="5px">
              Welcome To One Sushi Jasper!
            </CFView>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
